import { Component } from '@angular/core';
import { FeatureFlagDirective } from '../feature-flags/feature-flag.directive';
import { FeatureFlagService } from '../feature-flags/feature-flag.service';
import { DataRulesFoldersComponent } from './data-rules-folders-view/data-rules-folders/data-rules.component';
import { DataRulesComponent } from './data-rules.component';

/**
 * Switches between the folder and list view for data rules based on feature flag.
 * If the feature flag is enabled, the folder view is shown, otherwise the list view is shown.
 */
@Component({
  selector: 'app-data-rules-switch',
  standalone: true,
  imports: [FeatureFlagDirective, DataRulesFoldersComponent, DataRulesComponent],
  template: `
    <app-data-rules-folders *ffEnabled="flags.dataRulesFolders; else listView" />
    <ng-template #listView>
      <app-data-rules />
    </ng-template>
  `
})
export class DataRulesSwitchComponent {
  protected readonly flags = FeatureFlagService.FLAGS;
}
